import { Check } from 'lucide-react'

import { PageHeader } from '@/app/layouts/PageHeader'
import { SettingsSection, useLanguage } from '@/features/settings'
import { LOCALES, LOCALE_NAMES, useT } from '@/i18n'
import { cn } from '@/lib/cn'

/**
 * 界面语言。
 *
 * 选项名**一律用各语言自己的写法**（English / 日本語），不翻译成当前界面
 * 语言 —— 看不懂当前界面的人正是来这一页的人，「英语」对他没有帮助，
 * 「English」有。
 */
export function SettingsLanguagePage() {
  const { locale, change, saving } = useLanguage()
  const t = useT()

  return (
    <>
      <PageHeader title={t('language.title')} back />
      <SettingsSection title={t('language.interface')} description={t('language.hint')}>
        <div role="radiogroup" aria-label={t('language.interface')} className="space-y-2">
          {LOCALES.map((value) => {
            const selected = locale === value
            return (
              <button
                key={value}
                type="button"
                role="radio"
                aria-checked={selected}
                disabled={saving}
                onClick={() => void change(value)}
                className={cn(
                  'flex w-full items-center justify-between rounded-md border-2 px-4 py-3 text-[15px] transition-colors',
                  selected
                    ? 'border-brand-ink bg-brand-subtle font-bold'
                    : 'border-line hover:bg-surface-hover',
                )}
              >
                {/* 刻意不翻译：看不懂当前语言的人靠这个字形认出自己的语言 */}
                <span lang={value}>{LOCALE_NAMES[value]}</span>
                {selected && <Check className="size-5 shrink-0" aria-hidden />}
              </button>
            )
          })}
        </div>
      </SettingsSection>
    </>
  )
}
